import React from 'react'
import type { PropsWithChildren } from 'react'
import { FF_FAVUR_REDESIGN } from 'constants/featureFlags'
import useFeatureFlag from 'hooks/useFeatureFlag'
import PinLogin from 'pages/PinLogin'
import PinLoginRedesign from './pin-login'

const PinLoginWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  // TODO: Remove component after redesign is done
  const redesignFF = Boolean(useFeatureFlag(FF_FAVUR_REDESIGN))

  if (redesignFF) {
    return <PinLoginRedesign>{children}</PinLoginRedesign>
  }

  return <PinLogin>{children}</PinLogin>
}

export default PinLoginWrapper
